import { useDispatch } from 'react-redux';
import api from './axiosInstance.js';
import { setFontLoading } from '../redux/fontListSlice.js';
import { setPrompt } from '../redux/promptSlice.js';
import {
  setUploadImageDescription,
  setUploadImageError,
  setUploadImageLoading,
} from '../redux/uploadImageSlice.js';

export const useUploadImage = () => {
  const dispatch = useDispatch();
  const uploadImage = async (prompt, userImage, imageFileName) => {
    try {
      dispatch(setFontLoading(true));
      dispatch(setUploadImageLoading(true));
      const formData = {
        instruct_prompt: prompt,
        userImage,
        fileName: imageFileName,
      };

      const response = await api.post('/image-description', formData);
      dispatch(setPrompt(response.data.data.image_description));
      dispatch(setUploadImageDescription(response.data.data));
      return response.data.data;
    } catch (error) {
      dispatch(setUploadImageError(error.response.data.message));
      throw new Error(error.response.data.message);
    }
  };

  return uploadImage;
};
